/**
 * Project: dash-anexsys
 * FilePath: \src\components\LinkDialog.js
 * File: LinkDialog.js
 * Created Date: Friday, July 3rd 2020, 10:02:13 am
 * Author: Sam Lockwood (sam.lockwood@anexsys.com)
 * -----
 * Last Modified: Fri Jul 03 2020
 * Modified By: Sam Lockwood
 * -----
 * Copyright (c) 2020 Anexsys
 * ------------------------------------
 */
import React, { useState } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Select,
  MenuItem, TextField, FormControl, InputLabel, Typography, Snackbar, Icon } from '@material-ui/core'
import utils from '../utils/utils'

const timeUnits = ([
  { name: 'Minute', value: 1000 * 60 },
  { name: 'Hour', value: 1000 * 60 * 60 },
  { name: 'Day', value: 1000 * 60 * 60 * 24 },
])

const initialExpiry = { value: 1, unit: 1000*60*60*24 }

const LinkDialog = ({ open, handleClose, app, version, platform }) => {
  const [params, setParams] = useState('{}');
  const [expiry, setExpiry] = useState(initialExpiry);
  const [link, setLink] = useState('');
  const [error, setError] = useState('');
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const requestLink = async () => {
    console.log(app, version, platform, expiry, params)
    let parsedParams
    try {
      parsedParams = JSON.parse(params)
    } catch (e) {
      parsedParams = {}
      setError('JSON didn\'t parse - sending an empty object');
    }
      
    const shareLink = await utils.s3proxy.generateShareLink(app, platform, version, expiry.value * expiry.unit, parsedParams)
    setLink(shareLink);
  };

  const handleDialogClose = () => {
    setParams('{}');
    setLink('');
    setExpiry(initialExpiry);
    setError('');
    handleClose();
  }

  const copyToClipboard = async () => {
    console.log(navigator.clipboard);
    await navigator.clipboard.writeText(link);
    setSnackbarMessage('Link copied to clipboard')
  }

  const closeSnackbar = () => {
    setSnackbarMessage('');
  }

  return (
    <>
      <Dialog open={open} onClose={handleDialogClose} maxWidth='lg' fullWidth style={{}}>
        <DialogTitle style={{ textAlign: 'center' }}>Generating Share Link for {app} (v{version} on {platform})</DialogTitle>
        <DialogContent dividers style={{ textAlign: 'center' }}>
          <div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <TextField
                variant='outlined'
                label='Expiry Time'
                value={expiry.value}
                onChange={(ev) => setExpiry({ ...expiry, value: +ev.target.value })}
                type='number'
              />
              <FormControl variant='outlined'>
                <InputLabel>Time unit</InputLabel>
                <Select value={expiry.unit} onChange={(ev) => setExpiry({ ...expiry, unit: +ev.target.value })} label='Time unit'>
                  {timeUnits.map(t => <MenuItem value={t.value}>{t.name}</MenuItem>)}
                </Select>
              </FormControl>
            </div>
            <TextField
              label='JSON parameters'
              fullWidth
              value={params}
              onChange={ev => setParams(ev.target.value)}
              rows={4}
              multiline
              variant='outlined'
              style={{ margin: '20px 0' }}
            />
            {error && <Typography align='center' color='error'>{error}</Typography>}
            {link && 
              <TextField
                disabled
                fullWidth
                label='Share link'
                value={link}
                color='primary'
                variant='outlined'
                onClick={copyToClipboard}
              />}
          </div>
        </DialogContent>
        <DialogActions style={{ justifyContent:'space-evenly' }}>
          <Button onClick={handleDialogClose}>Close</Button>
          <Button onClick={requestLink}>Generate Link</Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={snackbarMessage}
        autoHideDuration={3000}
        onClose={closeSnackbar}
        message={snackbarMessage}
        action={
          <Icon size='small' onClick={closeSnackbar}>
            close
          </Icon>
        }
      />
    </>
  )
}

export default LinkDialog;